import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../../../context/AuthContext";
import { LoadingButton } from "@mui/lab";
import { SnackAlertContext } from "../../../../../context/SnackAlertContext";

const AdminCancelOrderDialog = ({ quoteId, open, onClose, onSuccess }) => {
  const { authToken, ezorder } = useContext(AuthContext);
  const { openSnackMessage } = useContext(SnackAlertContext);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [confirmText, setConfirmText] = useState(null);

  const handleClose = () => {
    // Reset and close
    setConfirmText("");
    setErrorMessage("");
    onClose();
  };

  const cancelOrder = async () => {
    try {
      setLoading(true);

      let formData = new FormData();
      formData.append("orderId", quoteId);
      formData.append("status", "CANCELLED");

      const response = await ezorder.patch(
        `/admin/orders/${quoteId}/status`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "content-type": "multipart/form-data",
          },
        }
      );

      if (response.status == 200 || response.status == 201) {
        openSnackMessage("success", "Cancelled");
        onSuccess();
        handleClose();
      } else {
        console.log(response);
        openSnackMessage("error", response.response.data.error);
      }
    } catch (error) {
      console.log(error);
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.log(error.response.data);
        console.log(error.response.status);
        console.log(error.response.headers);
        openSnackMessage("error", error.response.data.error);
      } else {
        // Something went really bad
        console.log(error);
        openSnackMessage("error", error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={() => {
        if (!loading) {
          handleClose();
        }
      }}
    >
      <DialogTitle>Cancel Order</DialogTitle>
      <DialogContent
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <DialogContentText>
          Please confirm you want to cancel this order by entering "cancel"
        </DialogContentText>
        <TextField
          sx={{ marginTop: "16px" }}
          variant="outlined"
          label="cancel"
          value={confirmText}
          onChange={(e) => {
            setConfirmText(e.target.value);
          }}
          size="large"
        />
      </DialogContent>
      <Box
        sx={{
          m: 1,
          position: "relative",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {errorMessage && (
          <Box>
            <Typography color={"red"}>{errorMessage}</Typography>
          </Box>
        )}
      </Box>
      <DialogActions>
        <LoadingButton
          loading={loading}
          onClick={() => {
            if (!loading) handleClose();
          }}
        >
          Cancel
        </LoadingButton>
        <LoadingButton
          disabled={confirmText != "cancel"}
          loading={loading}
          variant="contained"
          color="primary"
          onClick={() => {
            if (!loading) cancelOrder();
          }}
        >
          Approve
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default AdminCancelOrderDialog;
